export class AttributeDefinitionModel {
    Id: number;
    Title: string;
    Code: string;
    Sequence: number;
    AdjustmentFactor: number;

    constructor() {
        this.Title = "";
        this.Code = "";
    }

    get CodeAndTitle(): string {
        return this.Code + ' - ' + this.Title;
    }
}